module.exports = {"CostCenterId":"_","*CostCenterNo":{"label":"Cost Center ID","editable":true},"CostCenterName":{"label":"Cost Center Name","editable":true}}


//////////////////
// WEBPACK FOOTER
// ./src/components/_modules/BusinessUnitsAndCostCenters/CC-list/model.json
// module id = /yid
// module chunks = 12